import inlineSvgSprite from "inline-svg-sprite";
import svgIcons from "./icons.svg";

const ieSvg = () => {
  var isIexplorer = require('is-iexplorer');
  if (isIexplorer) {
    inlineSvgSprite(svgIcons, 'svg')
  }
}

export default ieSvg;